class Form {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init()
    })
  }

  init() {
    // Star rating functionality
    const starRatings = document.querySelectorAll('.star-rating')

    starRatings.forEach((rating) => {
      const stars = rating.querySelectorAll('.star')
      const input = rating.querySelector('input')

      function updateStars(value) {
        stars.forEach((star) => {
          const starValue = parseInt(star.dataset.value)
          star.classList.toggle('active', starValue <= value)
        })
      }

      stars.forEach((star) => {
        star.addEventListener('click', () => {
          const value = parseInt(star.dataset.value)
          input.value = value
          updateStars(value)
        })

        star.addEventListener('mouseover', () => {
          const value = parseInt(star.dataset.value)
          updateStars(value)
        })
      })

      rating.addEventListener('mouseleave', () => {
        updateStars(parseInt(input.value) || 0)
      })

      // Initialize stars based on input value
      if (input.value) {
        updateStars(parseInt(input.value))
      }
    })

    // File input name display
    const fileInputs = document.querySelectorAll('.file-input')

    fileInputs.forEach((input) => {
      input.addEventListener('change', function () {
        const fileName = this.files[0]?.name || 'Niciun fișier selectat'
        const field = this.closest('.field')
        const fileNameDisplay = field.querySelector('.control-filename')

        fileNameDisplay.classList.remove('is-hidden')
        fileNameDisplay.textContent = fileName
      })
    })

    // scroll to field.has-errors if existing
    const errorField = document.querySelector('.field.has-errors')
    if (errorField) {
      errorField.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }
}

const form = new Form()
export default form
